import React, { Fragment, useEffect, useContext } from "react";
import SidingColorColumns from "./SidingColorColumns";

const AllSidingColors = ({ sidingColors, setSelectedSidingColor, selectedSidingColor, settings, updateSettings }) => {
  const theTitle = "Siding Colors";

  return (
    <SidingColorColumns
      sidingColors={sidingColors}
      setSelectedSidingColor={setSelectedSidingColor}
      selectedSidingColor={selectedSidingColor}
      theTitle={theTitle}
      settings={settings}
      updateSettings={updateSettings}
    />
  );
};

export default AllSidingColors;
